import React, { useState, useEffect } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import {
  FormContainer,
  LoginTitle,
  LoginSubTitle,
  SignInButton,
  FirstAccessContainer,
  LoadingIcon,
  CustomLinkSpan,
} from './styles';
import { TimeExceeded } from '../../Auth/TimeExceeded';
import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";

export function CodeSentScreen({ handleSubmit }) {
  const [seconds, setSeconds] = useState(180);
  const [code, setCode] = useState(new Array(6).fill(''));
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const isInvalidCode = useSelector((state) => state.invalidCodeReducer.invalidCode);

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    }
    if (seconds <= 0) {
      TimeExceeded;
    }
  }, [seconds]);

  const handleChange = (value, index) => {
    if (/^\d?$/.test(value)) { 
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
  
      if (value.length === 1 && index < 5) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
      if (value === '' && index > 0) {
        document.getElementById(`code-input-${index - 1}`).focus();
      }
    }
  };

  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData('text').slice(0, 6); 
    if (pastedData.length === 6) {
      setCode(pastedData.split(''));
    }
  };

  const isCodeComplete = code.every(num => num !== '');

  const postValidationToken = async () => {
    const token = code.join('');
    setLoading(true);
    handleSubmit(token);
  };

  useEffect(() => {
    if (isInvalidCode) {
      setCode(new Array(6).fill(''));
      setLoading(false);
    }
  }, [isInvalidCode]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch({ type: 'SET_STEP', step: 0 });
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return (
    <>
      {seconds <= 0 ? (
        <TimeExceeded handleSubmit={handleSubmit} isMFA={true} />
      ) : (
        <FormContainer>
          <LoginTitle className="mb-3">
            {isInvalidCode ? (
              <>
                Código inválido <ClearIcon style={{ color: '#E8454F', fontSize: '30px' }} />
              </>
            ) : (
              <>
                Código enviado <CheckIcon style={{ color: '#47A150', fontSize: '30px' }} />
              </>
            )}
          </LoginTitle>

          <LoginSubTitle>
            {isInvalidCode ? 'Digite o código novamente' : 'Digite abaixo o código que você recebeu'}
          </LoginSubTitle>

          <div
            style={{
              display: 'flex',
              gap: '10px',
              justifyContent: 'center',
              paddingBottom: '30px',
            }}
          >
            {code.map((num, index) => (
                <input
                  key={index}
                  id={`code-input-${index}`}
                  value={num}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength="1"
                  onPaste={handlePaste}
                  {...(isMobile && { inputMode: "numeric", type: "tel" })} 
                  style={{
                    width: '40px',
                    height: '50px',
                    fontSize: '24px',
                    textAlign: 'center',
                    border: 'none',
                    borderBottom: '2px solid black',
                    outline: 'none',
                    color: '#000FFF',
                    borderBottomColor: '#000FFF',
                  }}
                />
            ))}
          </div>

          <LoginSubTitle style={{ color: '#000FFF' }} className="mb-3">
            {seconds} segundos restantes
          </LoginSubTitle>

          <SignInButton
            type="submit"
            className="mt-4"
            disabled={loading || !isCodeComplete}
            style={{
              backgroundColor: loading || !isCodeComplete ? 'gray' : '#000FFF',
              cursor: loading || !isCodeComplete ? 'not-allowed' : 'pointer',
            }}
            onClick={postValidationToken}
          >
            {loading ? (
              <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
            ) : (
              <span>Confirmar e ir para a página inicial</span>
            )}
          </SignInButton>

          <FirstAccessContainer className="mt-3 w-100" onClick={() => {
            dispatch({ type: "SET_STEP", step: 0 });
          }}>
            <SignInButton outline disabled={loading}>
              <span>Voltar</span>
            </SignInButton>
          </FirstAccessContainer>

          {isInvalidCode && (
            <FirstAccessContainer className="mt-3 w-100" onClick={() => {
              dispatch({ type: "SET_STEP", step: 0 });
            }}>
              <CustomLinkSpan>
                Obter código de outra maneira
              </CustomLinkSpan>
            </FirstAccessContainer>
          )}
        </FormContainer>
      )}
    </>
  );
}
